import { Button, ModalBody, Stack, Text, useToast } from "@chakra-ui/react";
import { Form, Icon, Modal } from "components";
import { API } from "config";
import { useEmployee } from "hooks";
import useWarehouseList from "hooks/useWarehouseList";
import { useState } from "react";

export default function Warehouse({ data, ...props }){

    const toast = useToast()
    const employee = useEmployee(data?.id)
    const list = useWarehouseList()
    const [ selected, setSelected ] = useState()
    const [ loading, setLoading ] = useState(false)

    const handleSubmit = async () => {
        if(!selected) return
        setLoading(true)

        try{
            await API.put(`/employees/${employee.data?.id}/warehouse/attach`, { distributor_id: selected })
            toast({ title: 'Colaborador vinculado', status: 'success' })
            employee.refetch()
            props?.onClose()
        }catch(err){
            toast({ title: 'Não foi possível vincular.', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <Modal title="Vincular colaborador à expedição" {...props}>
        <ModalBody> 
            <Stack spacing={4}>

                <Text fontSize="sm">Selecione o centro de distribuição que deseja vincular o colaborador:</Text>

                <Form.Select
                    required
                    label="Selecione um centro de distribuição:"
                    options={list.data?.map(item => ({ label: item.name, value: item.id }))}
                    onChange={e => setSelected(e.target.value)}
                    isDisabled={loading}
                />

                <Button isDisabled={!selected} isLoading={loading} leftIcon={<Icon name="warehouse" />} colorScheme="orange" onClick={handleSubmit}>Vincular colaborador</Button>
            </Stack>
        </ModalBody>
    </Modal>
    )
}